<template>
  <div class="home-container">
    <section id="home">
      <div class="arc-light"></div>
      <h1>让你每一眼看到的都是重点</h1>
      <p>Every glance, every focus</p>
    </section>
    <div class="divider"></div>
  </div>
</template>

<script>
export default {
  name: 'HomeView',
  mounted() {
    console.log('首页视图已挂载');
    console.log('路由状态:', this.$route.path);
  }
}
</script>

<style scoped>
.home-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: -60px; /* 抵消 main-content 的 padding-top，让首页从导航栏下方紧贴开始 */
}

#home {
  position: relative;
  overflow: hidden;
  background: #111;
  min-height: calc(100vh + 60px); /* 增加高度，包含导航栏的空间，确保填满整个视口 */
  width: 100%;
  padding: 100px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  box-sizing: border-box;
  max-width: 100%;
}

/* 首页文字放大和闪光效果 */
#home h1 {
  font-size: 3.5rem;
  margin-bottom: 1.5rem;
  position: relative;
}

#home p {
  font-size: 1.4rem;
  max-width: 800px;
  margin: 0 auto 2rem;
}

/* 修改闪光效果 */
.arc-light {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  z-index: 1;
  overflow: hidden;
  pointer-events: none;
}

.arc-light:after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 200%;
  height: 100%;
  background: linear-gradient(
      90deg,
      transparent 0%,
      rgba(255, 255, 255, 0.05) 10%,
      rgba(255, 255, 255, 0.1) 20%,
      rgba(255, 255, 255, 0.2) 30%,
      rgba(255, 255, 255, 0.4) 45%,
      rgba(255, 255, 255, 0.2) 60%,
      rgba(255, 255, 255, 0.1) 80%,
      rgba(255, 255, 255, 0.05) 90%,
      transparent 100%
  );
  filter: blur(8px);
  animation: moveArcLight 8s infinite linear;
  mix-blend-mode: screen;
}

@keyframes moveArcLight {
  0% {
      transform: translateX(-100%);
      opacity: 0;
  }
  10% {
      opacity: 1;
  }
  90% {
      opacity: 1;
  }
  100% {
      transform: translateX(100%);
      opacity: 0;
  }
}

#home h1, #home p {
  position: relative;
  z-index: 2;
  text-shadow: 0 0 10px rgba(0, 0, 0, 0.8);
}

.divider {
  width: 80%;
  max-width: 1200px;
  height: 2px;
  background: #e50914;
  margin: 0 auto;
}
</style>